import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import React, { useState } from "react";
import LoadingSpinner from "../LoadingSpinner";
import {useAppSelector} from "../../redux/hooks";
import {FaArrowLeft} from "react-icons/fa";
import { useAppDispatch } from "../../redux/hooks";
import {verifyEmail, verifyPhoneNumber} from "../../redux/selfService/selfServiceSlice";
import Modal from "../Base/Modal";
import {bool} from "yup";

interface PropsI {
    showModal: boolean;
    onClose: ()=>void;
    item: "email" | "phone";
    onSuccess: ()=>void;

}




const VerifyEmailPhone = ({ item, onClose, onSuccess, showModal }: PropsI)=>{
    const dispatch = useAppDispatch();
    const { isLoading, isSuccessful } = useAppSelector((state) => state?.selfService);

    const [error, setError] = useState<string | null>(null); // Track error message
 
    const validationSchema = Yup.object().shape({
        verificationCode: Yup.string().required("Verification code is required")
    });

    const { handleSubmit, register, setValue, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            verificationCode: "",
        }
    });

    // Clear error message when input text changes
  const onInputChange = () => {
    setError(null);
  };


    const onSubmit = async (values: any) =>{
        setError(null); // Clear error message when submitting

        if(item==="email"){
            let emailVerificationAction = await dispatch(verifyEmail({
                verificationCode: values.verificationCode
            }))

          //  console.log(emailVerificationAction);
         //   && emailVerificationAction?.payload.statusCode === "00"

            if(emailVerificationAction?.type === "selfService/verifyEmail/fulfilled"  && emailVerificationAction?.payload.statusCode === "00"){
                onSuccess()
            }
            else {

                setError(emailVerificationAction?.payload.statusMessage); // Set error message
              }
        } else {
            const phoneVerificationAction = await dispatch(verifyPhoneNumber({
                verificationCode: values.verificationCode
            }))

         //   console.log(phoneVerificationAction);
            if(phoneVerificationAction?.type === "selfService/verifyPhoneNumber/fulfilled" && phoneVerificationAction?.payload.statusCode === "00"){
                onSuccess()
            }
            else {
                setError(phoneVerificationAction?.payload.statusMessage);
               // setError("Email verification failed. Please try again."); // Set error message
              }
        }
    }

    return (
        <Modal showModal={showModal} onClose={onClose} >
        <div>
            <h1 className="text-xl text-center mb-16">Verify {item === "email" ? "Email" : "Phone Number"} to Continue</h1>
          
            {error && <div className="text-red-500 mb-4">{error}</div>} {/* Display error message */}
      
            <div className="input_container">
                <label className="input_title" htmlFor="email">
                   <b>Verification Code</b> 
                </label>
                <label className="input_title" htmlFor="email">
                {item === "email" ? "A code has been sent to your email" : "A code has been sent to your mobile number"}
                </label>
                <input
                    id="email"
                    className="input_field"
                    type="number"
                    placeholder={"Enter code here"}
                    {...register("verificationCode")}

                    onChange={onInputChange} 
         
                />
                {errors.verificationCode && (
                    <ErrorViewer message={errors.verificationCode.message as string}/>
                )}
            </div>

            <button
                onClick={handleSubmit(onSubmit)}
                className="btn btn-primary btn-primary-full"
                disabled={isLoading}
            >
                {isLoading ?
                    <LoadingSpinner color={"#305F32"} backgroundColor={""}/>
                    : item === "email" ? "Verify Email" : "Verify Phone Number"
                }
            </button>
        </div>
        </Modal>
    );
}

export default VerifyEmailPhone;